import { Grid } from '@mui/material'
import styled from 'styled-components'
import { ITheme } from 'theme/interface'

interface IMenuList {
  className?: string
  theme: ITheme
}

export const GridContent = styled(Grid)`
  width: 100%;
  max-width: ${({ noMaxWidth }: { noMaxWidth?: boolean }) =>
    noMaxWidth ? '100%' : '1280px'} !important;
  height: 100%;
  padding: 20px;
  position: relative;
  margin: 70px auto !important;
`

export const TopContent = styled.div`
  width: 100%;
  padding: 20px;

  .text-content {
    p,
    span {
      font-size: 14px !important;
      font-weight: 500 !important;
      color: ${({ theme }) => theme.colors.dark} !important;
    }

    p {
      font-weight: normal !important;
    }
  }

  .button-content {
    width: 100%;
    margin-top: 20px;
  }
`

export const Menu = styled.nav`
  margin-top: 20px;

  ul {
    width: 100%;

    li {
      width: 100% !important;
      list-style: none;

      button {
        width: 100%;
        background-color: transparent;
        height: 40px;
        border: none;
        text-align: left;
        font-size: 16px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.secondary};
        padding-left: 20px;
        outline: none !important;

        :disabled {
          opacity: 0.5;
          cursor: no-drop;
        }
      }
    }
  }
`

export const MenuList = styled.li<IMenuList>`
  width: 100%;
  background-color: ${({ className, theme }) =>
    className === 'active' ? theme.colors.background : 'transparent'};
  border-left: ${({ className, theme }) =>
    className === 'active'
      ? `2px solid ${theme.colors.secondary}`
      : 'none'} !important;

  border-top: 1px solid
    ${({ className, theme }) =>
      className === 'active' ? 'transparent' : theme.colors.gray10} !important;
  height: 40px;
  border: none;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.secondary};
`

export const PatientContent = styled.div`
  h3 {
    font-size: 18px !important;
    font-weight: 500 !important;
    color: ${({ theme }) => theme.colors.dark};
  }

  p {
    font-size: 14px !important;
    line-height: 20px !important;
    font-weight: normal !important;
    color: ${({ theme }) => theme.colors.gray80} !important;
    margin-top: 15px;

    span {
      font-weight: 600 !important;
    }
  }

  .PatientContent--header {
    @media screen and (min-width: 546px) {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: row;
    }
  }
`

export const SectionContent = styled.section`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.gray10};
  border-radius: ${({ theme }) => theme.radius.default}px;
  padding: 30px;

  span {
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 20px !important;
  }

  p {
    font-size: 14px !important;
    line-height: 18px !important;
    color: ${({ theme }) => theme.colors.gray50} !important;
  }

  .subsection {
    .subsection-item {
      display: flex;
      flex-direction: column;
      margin-bottom: 30px;

      span {
        font-size: 14px;
        color: ${({ theme }) => theme.colors.dark};
      }

      p {
        font-size: 14px !important;
        color: ${({ theme }) => theme.colors.dark} !important;
        font-weight: 600 !important;
        line-height: 22px !important;
      }

      .vital-content {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;

        .vital-content-left {
          width: 80%;
        }

        .vital-content-right {
          display: flex;
          flex: 1;
          justify-content: flex-start;
          padding-left: 10px;
        }

        .tag-container {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
          margin-top: 15px;
          margin-bottom: 15px;
        }

        .tag-button {
          border-radius: 50px;
          padding: 5px 10px;
          font-size: 16px;
        }
      }
    }

    .cards-prescriptions {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`

export const AttachmentsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 40px;

  .files {
    width: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
    border: none;
    outline: none;
    background-color: transparent;
    padding-top: 30px;

    img {
      width: 56px;
      height: 75.6px;
      margin-bottom: 10px;
    }

    span {
      max-width: 100px;
    }
  }

  .images {
    width: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
    border: none;
    outline: none;
    background-color: transparent;

    img {
      width: 100%;
      margin-bottom: 10px;
    }

    span {
      max-width: 200px;
    }
  }
`

export const NoData = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  img {
    width: 200px;
  }

  span {
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.gray80};
    margin-top: 30px;
  }
`

export const CardPrescriptionExams = styled.div`
  width: 100%;
  min-height: 100px;
  margin-bottom: 20px;
  padding: 14px;
  border: 1px solid ${({ theme }) => theme.colors.gray10};
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 150px;
  }

  span {
    color: ${({ theme }) => theme.colors.gray80};
    margin-bottom: 10px;
  }

  @media screen and (min-width: 961px) {
    width: calc(100% / 3 - 10px);
    margin-right: 5px;
    margin-left: 5px;
  }
`

export const cardNutritional = styled.div`
  > h2 {
    > strong {
      font-size: 16px !important;
      font-weight: 700 !important;
    }
  }
  > p {
    font-size: 14px !important;
    margin-bottom: 0;
    font-weight: 500 !important;
    > strong {
      font-size: 14px !important;
      color: ${({ theme }) => theme.colors.gray80};
      font-weight: 700 !important;
    }
  }

  > ul {
    margin: 15px;
  }

  pre {
    padding: 20px;
  }
`

export const ContentPagination = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: flex-end;
  flex-direction: column;
`
